import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

const Engineers = () => {
  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Engineers'}]}/>
      <Paper>
        <Table/>
      </Paper>
    </div>
  );
};

export default Engineers;
